export default function getNewOptionValue(
    arrayOfChosen: string[],
    newValue?: string
): string[] {
    if (!newValue || typeof newValue === 'undefined') {
        return arrayOfChosen
    }

    if (arrayOfChosen.includes(newValue)) {
        return arrayOfChosen.filter((chosenValue) => chosenValue !== newValue)
    }

    return [...arrayOfChosen, newValue]
}
